module.exports = __webpack_public_path__ + "static/scale-model-of-frank-zappa-statue-in-baltimore-maryland-68479b102e447d48a433243fb82e671f.png";